let module_name = "services.undefined-data";
let $inject = [];

class UndefinedDataService {
  constructor() {
  }

  replace(data, default_value = "") {
    data = angular.copy(data);
    for (const dataKey in data) {
      if (typeof data[dataKey] === "undefined") {
        data[dataKey] = default_value;
      }
    }
    return data;
  }
}

UndefinedDataService.$inject = $inject;

//noinspection JSValidateTypes
export default angular.module(module_name, [])
  .service("UndefinedDataService", UndefinedDataService)
  .name;



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/services/undefined-data.service.js
 **/